'use client';
import clsx from 'clsx';
import { OpenAPISelect, OpenAPISelectItem, useSelectState } from './OpenAPISelect';
import { StaticSection } from './StaticSection';
import { createStateKey, getStatusCodeClassName } from './utils';
/**
 * Get the state of the response examples select.
 */
export function useResponseExamplesState(blockKey, initialKey) {
    if (initialKey === void 0) { initialKey = 'default'; }
    return useSelectState(getResponseExampleStateKey(blockKey), initialKey);
}
export function OpenAPIResponseExampleContent(props) {
    var blockKey = props.blockKey, items = props.items, selectIcon = props.selectIcon;
    return (<StaticSection header={<OpenAPIResponseExampleHeader selectIcon={selectIcon} blockKey={blockKey} items={items}/>} className="openapi-response-examples">
            <OpenAPIResponseExampleBody blockKey={blockKey} items={items}/>
        </StaticSection>);
}
function OpenAPIResponseExampleHeader(props) {
    var items = props.items, blockKey = props.blockKey, selectIcon = props.selectIcon;
    if (items.length === 1) {
        var item = items[0];
        if (!item) {
            return null;
        }
        return (<span className="openapi-response-examples-statuscode-title">
                <span className={clsx('openapi-statuscode', "openapi-statuscode-".concat(getStatusCodeClassName(item.statusCode)), 'openapi-response-examples-statuscode')}>
                    {item.statusCode}
                </span>
                <span>{item.label}</span>
            </span>);
    }
    return (<OpenAPISelect items={items} icon={selectIcon} stateKey={getResponseExampleStateKey(blockKey)} placement="bottom start">
            {items.map(function (item) { return (<OpenAPISelectItem key={item.key} id={item.key} value={item}>
                    <span className={clsx('openapi-statuscode', "openapi-statuscode-".concat(getStatusCodeClassName(item.statusCode)), 'openapi-response-examples-statuscode')}>
                        {item.statusCode}
                    </span>
                    <span>{item.label}</span>
                </OpenAPISelectItem>); })}
        </OpenAPISelect>);
}
function OpenAPIResponseExampleBody(props) {
    var _a, _b;
    var blockKey = props.blockKey, items = props.items;
    var state = useResponseExamplesState(blockKey, (_a = items[0]) === null || _a === void 0 ? void 0 : _a.key);
    var selectedItem = (_b = items.find(function (item) { return item.key === state.key; })) !== null && _b !== void 0 ? _b : items[0];
    if (!selectedItem) {
        return null;
    }
    return <div className="openapi-response-examples-panel">{selectedItem.body}</div>;
}
/**
 * Return the state key for the response examples.
 */
function getResponseExampleStateKey(blockKey) {
    return createStateKey('openapi-responses', blockKey);
}
